import { FundingActivityStatus } from "../enums"; 
import { IAPIFundingPayoutModel, IAPIFundingReferenceModel } from "../interfaces/IAPIContactModels";

 
export class FundingActivityModel {
    balance: number;
    payouts: FundingPayoutModel[];
    constructor(data?: Partial<FundingActivityModel>) {
        this.balance = data?.balance || 0;
        this.payouts = (data?.payouts || []).map((item) => new FundingPayoutModel(item));
    }

    static deserializeAPIModel(data: IAPIFundingReferenceModel): FundingActivityModel {
        const mappedData: Partial<FundingActivityModel> = {
            balance: data.balance,
            payouts: data.payouts.map((item) => FundingPayoutModel.deserializeAPIModel(item)),
        };
        return new FundingActivityModel(mappedData);
    }
}

export class FundingPayoutModel {
    date: string;
    amount: number;
    status: keyof typeof FundingActivityStatus;
    merchantAccountId: string;
    payoutId: string;
    constructor(data?: Partial<FundingPayoutModel>) {
        this.date = data?.date || '';
        this.amount = data?.amount || 0;
        this.status = (data?.status as keyof typeof FundingActivityStatus) || FundingActivityStatus.Scheduled;
        this.merchantAccountId = data?.merchantAccountId || '';
        this.payoutId = data?.payoutId || '';
    }

    static deserializeAPIModel(data: IAPIFundingPayoutModel): FundingPayoutModel {
        return new FundingPayoutModel(data);
    }
}
